module.exports = __webpack_public_path__ + "static/media/cablecircle4.54ff11a0.png";